import { MutationTree } from 'vuex';
import { IImportData } from '../types/import-data';
import { EImportFilesStage } from '../types/enums/import-files-stage';
import { IFileImport } from '../types/file-import';
import { EImporterMutation } from './importer.constants';
import { IImporterState } from './importer.types';
import { IDocument } from '@lib-shared/types/Document';
import { IDocumentPage } from '@lib-shared/types/document-page';
import { IWordMerge } from '@/document-edit/assembler/types/word-merge';

export const mutations: MutationTree<IImporterState> = {
  [EImporterMutation.SetState](state: IImporterState, newState: IImporterState) {
    state.imported = newState.imported;
    state.importing = newState.importing;
    state.importedPages = newState.importedPages;
    state.importedDocument = newState.importedDocument;

    state.importData.error = newState.importData.error;
    state.importData.title = newState.importData.title;
    state.importData.type = newState.importData.type;
    state.importData.stage = newState.importData.stage;

    state.fileImport.fileCount = newState.fileImport.fileCount;
    state.fileImport.pageCount = newState.fileImport.pageCount;
    state.fileImport.recievedFileImportCount = newState.fileImport.recievedFileImportCount;

    state.wordMerge.filename = newState.wordMerge.filename;
    state.wordMerge.index = newState.wordMerge.index;
    state.wordMerge.isDynamic = newState.wordMerge.isDynamic;
    state.wordMerge.missing = newState.wordMerge.missing;
  },
  [EImporterMutation.SetImported](state: IImporterState, imported: boolean) {
    state.imported = imported;
  },
  [EImporterMutation.SetImporting](state: IImporterState, importing: boolean) {
    state.importing = importing;
  },
  [EImporterMutation.SetError](state: IImporterState, error: string) {
    state.importData.error = error;
  },
  [EImporterMutation.SetImportedDocument](state: IImporterState, document: IDocument) {
    state.importedDocument = document;
  },
  [EImporterMutation.SetImportData](state: IImporterState, importData: IImportData) {
    state.importData = importData;
  },
  [EImporterMutation.SetImportStage](state: IImporterState, stage: EImportFilesStage) {
    state.importData.stage = stage;
  },
  [EImporterMutation.SetImportedPages](state: IImporterState, pages: IDocumentPage[]) {
    state.importedPages = pages;
  },
  [EImporterMutation.SetWordMerge](state: IImporterState, wordMerge: IWordMerge) {
    state.wordMerge = wordMerge;
  },
  [EImporterMutation.SetFileImportProperties](
    state: IImporterState,
    fileDataProperty: Partial<IFileImport>
  ) {
    state.fileImport = { ...state.fileImport, ...fileDataProperty };
  },
};
